const UNBINDED_SUBCATEGORIES = "UNBINDED_SUBCATEGORIES";
const UNBINDED_SUBCATEGORIES_SUCCESS = "UNBINDED_SUBCATEGORIES_SUCCESS";
const UNBINDED_SUBCATEGORIES_FAILURE = "UNBINDED_SUBCATEGORIES_FAILURE";
const CLEAR_UNBINDED_SUBCATEGORIES = "CLEAR_UNBINDED_SUBCATEGORIES";

const unbindedSubcategoriesSymbols = {
  UNBINDED_SUBCATEGORIES_SUCCESS,
  UNBINDED_SUBCATEGORIES_FAILURE,
  UNBINDED_SUBCATEGORIES,
  CLEAR_UNBINDED_SUBCATEGORIES,
};
export default unbindedSubcategoriesSymbols;
